<div class="left-modal">
  @if (loading) {
    <div class="loader"></div>
  }
  <div class="close" (click)="close()"></div>
  @if (!loading) {
    <div class="modal-container">
      <div class="modal-info-container">
        <h1>{{'Catering' | translate}}</h1>
        <div class="boxContainer">
          @if (cateringFiles.length) {
            <div class="L-12 M-12 S-12 columns noMargin">
              <div class="box" style="padding-bottom: 0;">
                <app-service-files-view
                  [service]="selectedCatering"
                  [files]="cateringFiles"
                  [fileNameProperty]="'file'"
                  [type]="'catering'"
                  (notify)="update()">
                </app-service-files-view>
              </div>
            </div>
          }
          @if (showProject) {
            <div class="L-12 M-12 S-12 columns noMargin">
              <div class="box">
                <label>{{'Project' | translate}}</label>
                {{selectedCatering.title}}
              </div>
            </div>
          }
          @if (!isShooting) {
            <div class="L-6 M-6 S-6 columns noMargin">
              <div class="box">
                <label>{{'Date' | translate}}</label>
                {{selectedCatering.date | date:'MMM-dd-y'}}
              </div>
            </div>
          }
          @if (!isShooting) {
            <div class="L-6 M-6 S-6 columns noMargin">
              <div class="box">
                <label>{{'Unit' | translate}}</label>
                {{selectedCatering.unit_number ? selectedCatering.unit_number : '--'}}
              </div>
            </div>
          }
          <div class="L-4 M-4 S-4 columns noMargin">
            <div class="box">
              <label>{{'Status' | translate}}</label>
              {{_gS.backTranslate(selectedCatering, 'se_st_name','--')}}
            </div>
          </div>
          <div class="L-4 M-4 S-4 columns noMargin">
            <div class="box">
              <label>{{'Type' | translate}}</label>
              {{_gS.backTranslate(selectedCatering, 'catering_name','--')}}
            </div>
          </div>
          <div class="L-4 M-4 S-4 columns noMargin">
            <div class="box">
              <label>{{'Time' | translate}}</label>
              {{selectedCatering.time ? (_gS.getStaticDateHour(selectedCatering.time) | date: 'h:mm a' ): '--:-- --'}}
            </div>
          </div>
          <div class="L-4 M-4 S-4 columns noMargin">
            <div class="box">
              <label>{{'Quantity' | translate}}</label>
              {{selectedCatering.quantity ? selectedCatering.quantity : '--'}}
            </div>
          </div>
          <div class="L-4 M-4 S-4 columns noMargin">
            <div class="box">
              <label>{{'Unit cost' | translate}}</label>
              {{selectedCatering.cost_unit ? (selectedCatering.cost_unit | currency: '$') : '--'}}
            </div>
          </div>
          <div class="L-4 M-4 S-4 columns noMargin">
            <div class="box">
              <label>{{'Total' | translate}}</label>
              {{selectedCatering.total_cost ? (selectedCatering.total_cost | currency: '$'): '--'}}
            </div>
          </div>
          @if (!isShooting) {
            <div class="L-6 M-6 S-6 columns noMargin">
              <div class="box">
                <label>{{'Purchase order' | translate}}</label>
                {{selectedCatering.po ? selectedCatering.po : '--'}}
              </div>
            </div>
          }
          @if (!isShooting) {
            <div class="L-6 M-6 S-6 columns noMargin">
              <div class="box">
                <label>{{'Invoice' | translate}}</label>
                {{selectedCatering.invoice ? selectedCatering.invoice : '--'}}
              </div>
            </div>
          }
        </div>
        @if (!isShooting && !isUpdatingCatering) {
          <div class="button-status-wrapper">
            @if (selectedCatering.service_statuses_id == 2 || selectedCatering.service_statuses_id == 4) {
              <div class="L-12 M-12 S-12 columns TextCentered">
                <input (click)="changeCateringStatus(1)"  name="sumbit" type="submit" value="{{'Mark as new' | translate}}" >
              </div>
            }
            @if (selectedCatering.service_statuses_id == 1 || selectedCatering.service_statuses_id == 3 || selectedCatering.service_statuses_id == 4) {
              <div class="L-12 M-12 S-12 columns TextCentered"
                >
                <input (click)="changeCateringStatus(2)" name="sumbit" type="submit" value="{{'Mark as pending' | translate}}" >
              </div>
            }
            @if (selectedCatering.service_statuses_id == 1 || selectedCatering.service_statuses_id == 3) {
              <div class="L-12 M-12 S-12 columns TextCentered">
                <input (click)="changeCateringStatus(4)"  name="sumbit" type="submit" value="{{'On process' | translate}}" >
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</div>